import { AuxiliumComponent } from "../auxilium-component";

export class DropdownGroup extends AuxiliumComponent {
	constructor() {
		super();

		this.label = this.getAttribute("label") ?? "";
		this.size = this.getAttribute("size") ?? "5";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("chip-header", this.label, { size: this.size }));
	}
}